import prixApi from '@/api/prix.api'

const getDefaultState = () => {
  return {
    evolutionPrixContratGestionDeleguee: {}
  }
}

const module = {
  namespaced: true,
  state: getDefaultState(),

  getters: {
    evolutionPrixContratGestionDeleguee (state) {
      return state.evolutionPrixContratGestionDeleguee
    }
  },
  mutations: {
    SET_EVOLUTION_PRIX_GESTION_DELEGUEE (state, evolutionPrixContratGestionDeleguee) {
      state.evolutionPrixContratGestionDeleguee = evolutionPrixContratGestionDeleguee
    }
  },
  actions: {
    getEvolutionPrixContratGestionDeleguee ({ commit, rootGetters }, codeGraineRs3) {
      const adherent = rootGetters['adherent/adherent']
      const anneeRecolte = rootGetters['application/anneeRecolteActive'] != null ? rootGetters['application/anneeRecolteActive'] : rootGetters['application/anneeRecolteEnCours']
      return prixApi.getEvolutionPrixContratGestionDeleguee(adherent.codeRegion, anneeRecolte, codeGraineRs3)
        .then(result => {
          return commit('SET_EVOLUTION_PRIX_GESTION_DELEGUEE', result)
        })
    }
  }
}

export default module
